import React from "react";
import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface OcAppRefreshCounterProps {
  timeToRefresh: number;
}

export const OcAppRefreshCounter: React.FC<OcAppRefreshCounterProps> = ({
  timeToRefresh,
}) => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      alignItems="center"
      flexDirection="row"
      justifyContent="center"
      textAlign="center"
      width="56px"
      height="40px"
      style={{
        backgroundColor: "#f1f3f4",
        color: "#cc0033",
        borderRadius: "4px",
        border: "1px solid #C6CACC",
      }}
    >
      <Typography variant="h5" color={theme.palette.primary.main}>
        {timeToRefresh}
      </Typography>
    </Box>
  );
};

export default OcAppRefreshCounter;
